(function() {
    if (!window.__event_resize__) {
        window.__event_resize__ = [];
    }

    if (window.__event_resize__.length === 0) {
        let _timer = null;
        window.__is_mobile__ = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || window.innerWidth <= 768;
        window.__get_node_list__ = (node) => {

            var list = Array.prototype.slice.call(node.querySelectorAll('[node-name]'), 0);
            var nodeList = {};

            list.forEach(function(el) {
                var name = el.getAttribute('node-name');

                if (name in nodeList) {
                    nodeList[name] = [].concat(nodeList[name], el);
                } else {
                    nodeList[name] = el;
                }
            });

            return nodeList;
        };

        window.__get_offset__ = (el) => {
            let box = el.getBoundingClientRect();
            let body = document.body;
            let clientTop = el.clientTop || body.clientTop || 0;
            let clientLeft = el.clientLeft || body.clientLeft || 0;
            let scrollTop = window.scrollY || el.scrollTop;
            let scrollLeft = window.scrollX || el.scrollLeft;
            return {
                top: box.top + scrollTop - clientTop,
                left: box.left + scrollLeft - clientLeft,
                scrollTop,
                scrollLeft
            };
        };
        window.__event_resize__.push(0);
        window.addEventListener('resize', function() {
            clearTimeout(_timer);
            _timer = setTimeout(() => {
                window.__is_mobile__ = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || window.innerWidth <= 768;
                window.__event_resize__.forEach(fn => {
                    fn && fn({
                        mode: window.__is_mobile__ ? 'h5' : 'pc'
                    });
                });
            }, 100);
        });
    }
})();